module.exports = __webpack_public_path__ + "static/img/dbsydx.8fb15e42.jpg";